import React, { useState } from "react";
import Modal from "../Modal";
import { useDispatch } from "react-redux";
import {
  courseStatusChanged,
  getCourses,
} from "../../features/slices/coursesManagement";
import { toastService } from "../../utils/toastify";

const DelteCourse = ({ setUpdateState, id }) => {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const handleClose = () => {
    setUpdateState((prev) => ({
      ...prev,
      deleteModal: false,
    }));
  };
  const validateForm = () => {
    let formErrors = {};
    if (!reason?.trim()) {
      formErrors.reason = "Reason is required"; // Error message for empty reason
    }
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // Returns true if no errors
  };
  const handleDelete = () => {
    setLoading(true);
    dispatch(
      courseStatusChanged({ id, deleteReason: reason, status: "DELETED" })
    ).then((res) => {
      if (res?.payload?.code == 200) {
        setLoading(false);
        toastService.success("Course deleted successfully");
        dispatch(getCourses());
        setUpdateState((prev) => ({
          ...prev,
          deleteModal: false,
          id: "",
        }));
      } else {
        setLoading(false);
      }
    });
  };
  const handleDeletePost = () => {
    if (validateForm()) {
      // Only call handleDelete if validation passes
      handleDelete();
    }
  };
  return (
    <Modal>
      <div className="modal-body">
        <div className="Category">
          <a className="CloseModal" onClick={handleClose}>
            ×
          </a>
          <h3>Delete Course</h3>
          <div className="form-group">
            <label>Enter reason to remove the course</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter the reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
            {errors.reason && (
              <p className="d-flex justify-content-start text-danger mt-2">
                {errors.reason}
              </p>
            )}
          </div>
          {/* <h4> */}
          {/* <a onClick={handleClose}>no</a> */}
          {/* <a onClick={handleDelete}>Yes</a> */}
          {/* </h4> */}
          <button
            className="Button"
            onClick={handleDeletePost}
            disabled={loading}
          >
            Delete Course
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DelteCourse;
